"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var _connectors;
            (function (_connectors) {
                class InitArgs {
                    constructor() {
                        this.fireEventStatusChanged = appn.emptyString;
                        this.fireEventOverdue = appn.emptyString;
                    }
                }
                let _initArgs;
                let _restHeaderTemplate = appn.emptyString;
                function init(args) {
                    _initArgs = args;
                    const restHeaderTemplate = $('#RESTHeaderRowTemplate');
                    _restHeaderTemplate = restHeaderTemplate.html();
                    restHeaderTemplate.remove();
                    appn.ui.formExpansionHelper.init('.connector');
                    addEvents();
                    window.focusEnabled = true;
                    registerFormExpansionHelper();
                    appn.select.init({ selector: '.box.connector select.httpVerb,.box.connector select.formatType', omitWidth: true });
                }
                _connectors.init = init;
                function addEvents() {
                    $('.fire-event').on('change', function () {
                        const thisVal = $(this);
                        const connector = thisVal.closest('.connector');
                        const fireEventStatus = connector.find('.fire-event-status, .fire-event-status-label');
                        if (thisVal.val() === _initArgs.fireEventStatusChanged) {
                            fireEventStatus.removeClass('d-none');
                            appn.select.init({
                                selector: '.fire-event-status'
                            });
                        }
                        else {
                            fireEventStatus.addClass('d-none');
                            appn.select.init({
                                selector: '.fire-event-status'
                            });
                        }
                        const fireEventByDays = connector.find('.fire-event-by-days, .fire-event-by-days-label');
                        if (thisVal.val() === _initArgs.fireEventOverdue)
                            fireEventByDays.removeClass('d-none');
                        else
                            fireEventByDays.addClass('d-none');
                        appn.select.init({ selector: '.box.connector .fire-event,.box.connector .fire-event-status' });
                    }).change();
                    $('.connector').on('click', '.buildIcon', function () {
                        const thisVal = $(this);
                        const formulaBox = thisVal.closest('.input-group').find('.form-control');
                        appn.ui.formulabuilder.currentFormula = formulaBox.val();
                        appn.ui.formulabuilder.currentMode = thisVal.data('type');
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            formulaBox.val(formula);
                        };
                        appn.ui.formulabuilder.showDialog();
                    });
                    $('.btn-clone-connector').click(function () {
                        const connectorId = $(this).closest('.connector').prop('id');
                        const form = $('form#appnForm');
                        form.append(`<input type="hidden" name="submitType" value="clone${connectorId}" />`);
                        form.submit();
                    });
                    $('.btnTryAddConnector').off().on('click', function (event) {
                        event.preventDefault();
                        $('#addConnector').click();
                    });
                }
                function registerFormExpansionHelper() {
                    appn.ui.formExpansionHelper.registerHandler('restHeaders', function (common, show, hide) {
                        return {
                            open: function (key, link, expansion) {
                                common.open(key, link, expansion);
                                if (expansion.find('.rest-header').length === 0)
                                    expansion.find('.add-header a').click();
                            },
                            insert: function (key, link, expansion) {
                                const headers = expansion.find('.headersRow');
                                const connectorIdx = expansion.closest('.connector').data('connector-index');
                                const newRowIdx = (new Date()).getTime();
                                const templateHtml = _restHeaderTemplate
                                    .replace(/ConnectorsREST\[0\]/g, `ConnectorsREST[${connectorIdx}]`)
                                    .replace(/ConnectorsREST_0__/g, `ConnectorsREST_'${connectorIdx}'__`)
                                    .replace(/Headers\[0\]/g, `Headers[${newRowIdx}]`)
                                    .replace(/Headers_0__/g, `Headers_${newRowIdx}__`);
                                const newRow = $(templateHtml);
                                newRow.find('input').val('');
                                newRow.find('.rowIndexer').val(newRowIdx);
                                newRow.insertBefore(link.parent());
                            },
                            close: function (key, link, expansion) {
                                link.closest('.rest-header').remove();
                                const headerRows = expansion.find('.rest-header');
                                if (headerRows.length === 0)
                                    common.close(key, link, expansion);
                            }
                        };
                    });
                }
            })(_connectors = taskTemplates._connectors || (taskTemplates._connectors = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
